// extracted by mini-css-extract-plugin
export default {"barchart_section":"BarChart_barchart_section__ttJ0u","bar_chart":"BarChart_bar_chart__pR+JF","recharts-surface":"BarChart_recharts-surface__Rvjcn"};